import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import $ from 'jquery';
import { isEqual } from "lodash";
import React, { Component } from 'react';
import DebounceInput from "react-debounce-input";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import Icon from "../../icon/icon.component.jsx";
import { getDefaultView } from '../../listing/generic-listing/utils';
import FilterDropdown from "./filterDropdown.component.jsx";
import FilterListModal from "./filterListModal.component.jsx";
import './filterToolbar.styles.scss';
import SavedFilterAlert from "./savedFilterAlert.component.jsx";
import SavedFilterModal from "./savedFilterModal.component.jsx";

const messages = defineMessages({
    "isNot": {
        id: "common.search_filter.operation.isNot",
        defaultMessage: "is not",
    },
    "contains": {
        id: "common.search_filter.operation.contains",
        defaultMessage: "contains",
    },
    "doesNotContains": {
        id: "common.search_filter.operation.doesNotContains",
        defaultMessage: "does not contains",
    },
    "startWith": {
        id: "common.search_filter.operation.startWith",
        defaultMessage: "start with",
    },
    "endWith": {
        id: "common.search_filter.operation.endWith",
        defaultMessage: "end with",
    },
    "is": {
        id: "common.search_filter.operation.is",
        defaultMessage: 'is',
    },
    "isNotOneOf": {
        id: "common.search_filter.operation.isNotOneOf",
        defaultMessage: "is not one of",
    },
    "isOneOf": {
        id: "common.search_filter.operation.isOneOf",
        defaultMessage: 'is one of',
    },
    "greaterOrEqualThan": {
        id: "common.search_filter.operation.greaterOrEqualThan",
        defaultMessage: "greater or equal than",
    },
    "greaterThan": {
        id: "common.search_filter.operation.greaterThan",
        defaultMessage: "greater than",
    },
    "lowerOrEqualThan": {
        id: "common.search_filter.operation.lowerOrEqualThan",
        defaultMessage: "lower or equal than",
    },
    "lowerThan": {
        id: "common.search_filter.operation.lowerThan",
        defaultMessage: "lower than",
    },
    "within": {
        id: "common.search_filter.operation.within",
        defaultMessage: "within the last",
    },
    "between": {
        id: "common.search_filter.operation.between",
        defaultMessage: "between",
    },
    "clear_all_filters": {
        id: "common.search_filter.btn.clear_view",
        defaultMessage: "Clear view",
    },
    "save": {
        id: "common.search_filter.text.save",
        defaultMessage: "Save",
    },
    "save_as_new": {
        id: "common.search_filter.text.save_as_new_view",
        defaultMessage: "Save as new view",
    },
    "settings": {
        id: "common.search_filter.text.settings",
        defaultMessage: "Settings",
    },
})

const saveIcon = <Icon value="save" />
const createIcon = <Icon value="plus-circle" />
const settingIcon = <Icon value="cog" />

class FilterToolbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            objectType: 'invoices',
            modal: '',
            options: [],
            saveAsNew: false,
            userId: AppContext.getUserLoggedIn().id,
            onSaveClicked: false,
            createdByCurrentUser: false,
            hideFilters: props.hideFilters || false,
            hideFilterDropdown: props.hideFilterDropdown || false,
            view: props.view || { columns: [] }
        }
        this.getModal = this.getModal.bind(this)
        this.getSavedFilterModal = this.getSavedFilterModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
        this.onUpdatedSavedFilter = this.onUpdatedSavedFilter.bind(this)
        this.onSaveAsNewClicked = this.onSaveAsNewClicked.bind(this)
        this.onSettingsClicked = this.onSettingsClicked.bind(this)
        this.onSaveClicked = this.onSaveClicked.bind(this)
        this.compareFilters = this.compareFilters.bind(this)
        this.checkCreator = this.checkCreator.bind(this)
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    componentDidMount() {
        AppContext.getApiClient().get('/listing/' + this.props.listingType + '/saved-filters').then(res => {
            if (Object.keys(res).length > 0) {
                this.setState({ options: res.data })
            }
        })
    }

    checkCreator(createdByUserId) {
        if (createdByUserId) {
            this.setState({
                createdByCurrentUser: true
            })
        } else {
            this.setState({
                createdByCurrentUser: false
            })
        }
    }

    compareFilters() {
        let isModified = false
        if (Object.keys(this.state.options).length > 0) {
            var match = this.state.options.find(filter => filter.id === this.props.savedFilterId)

            var filter = Base64.encode(JSON.stringify({
                filters: this.props.filtersToUse,
            }))

            if (match) {
                const areFiltersModified = filter !== match.attributes.content
                const isViewModified = !isEqual(match.attributes.view, this.props.view)
                isModified = areFiltersModified || isViewModified
            }
        }
        return isModified
    }

    isCustomViewApplied() {
        const defaultView = getDefaultView(this.props.listingType)
        return defaultView.columns.length // This is a temporary fix to support legacy listings before refactoring
            ? this.props.savedFilterId || !isEqual(defaultView, this.props.view)
            : false
    }


    onSaveClicked() {

        this.setState({
            onSaveClicked: true,
        })

        var filter = Base64.encode(JSON.stringify({
            filters: this.props.filtersToUse,
        }))

        AppContext.getApiClient().patch('/saved-filters/' + this.props.savedFilterId, {
            content: filter,
            view: this.props.view,
        }).then((res) => {
            let filterObject = {
                "attributes": {
                    "name": res.attributes.name,
                    "visibility": res.attributes.visibility,
                    "listingType": res.attributes.listingType,
                    "content": filter,
                    "createdBy": this.state.userId,
                    "view": this.props.view,
                },
                "id": res.id,
            }
            this.onUpdatedSavedFilter(filterObject)
            setTimeout(() => {
                this.setState({
                    onSaveClicked: false
                });
            }, 4000)
        })
    }

    onSettingsClicked() {
        this.setState({
            saveAsNew: false,
        }, () => this.getSavedFilterModal())
    }

    onSaveAsNewClicked() {
        this.setState({
            saveAsNew: true,
        }, () => this.getSavedFilterModal())
    }

    onUpdatedSavedFilter(option) {
        var copyOfOptions = [...(this.state.options)];
        var match = copyOfOptions.find(filter => filter.id === option.id)
        if (match && option.attributes.name !== "") {
            var slicedOption = copyOfOptions.filter(item => item != match)
            slicedOption.push(option)
            this.setState({
                options: slicedOption
            })
        }
        else if (match && option.attributes.content === '') {
            var slicedOption = copyOfOptions.filter(item => item != match)
            this.setState({
                options: slicedOption,
                filterCleared: true,
            }, () => {
                this.props.onClearFilters()
            })
        }
        else if (!match && option.attributes.content !== '') {
            copyOfOptions.unshift(option)
            this.setState({
                options: copyOfOptions,
            }, () => this.props.onChangeSavedFilter(option.id, option.attributes.content, option.attributes.view))
        }
    }

    closeModal() {
        $('#filtersMenus').modal('hide')
        $('#savedFiltersMenu').modal('hide')
        this.setState({
            modal: ''
        })
    }

    getSavedFilterModal() {
        this.setState({
            modal: <SavedFilterModal
                filterId={this.props.savedFilterId}
                filtersToUse={this.props.filtersToUse}
                listingType={this.props.listingType}
                onSaveAsNew={this.state.saveAsNew}
                onUpdatedSavedFilter={this.onUpdatedSavedFilter}
                onCloseModal={this.closeModal}
                userId={this.state.userId}
                view={this.props.view}
            />
        })
    }

    getModal() {
        this.setState({
            modal: <FilterListModal
                filterOptions={this.props.filterOption}
                filtersToUse={this.props.filtersToUse}
                filters={this.props.filtersApplied}
                onChangeFilter={this.props.onChangeFilter}
                onCloseModal={this.closeModal}
                savedFilter={this.state.savedFilterId}
            />
        })
    }

    removeFilter(id) {
        let newFiltersToUse = Object.assign(this.props.filtersToUse);
        delete newFiltersToUse[id]
        if (Object.keys(newFiltersToUse).length === 0) {
            this.props.onClearFilters()
        }
        this.props.onChangeFilter(newFiltersToUse)
    }


    render() {
        let saveAsNewButton =
            <a key="save_as_new" type="button" href="#savedFiltersMenu" data-toggle="modal" data-target="#savedFiltersMenu" className="text-primary small mr-3" onClick={this.onSaveAsNewClicked}>
                {createIcon}{this.props.intl.formatMessage(messages["save_as_new"])}
            </a>;
        let saveButton =
            <a key="save_button" type="button" href="#" className="text-primary small mr-3" onClick={this.onSaveClicked}>
                {saveIcon}{this.props.intl.formatMessage(messages["save"])}
            </a>;
        let settingsButton =
            <a key="settings_button" type="button" href="#savedFiltersMenu" data-toggle="modal" data-target="#savedFiltersMenu" className="text-primary small mr-3" onClick={this.onSettingsClicked}>
                {settingIcon}{this.props.intl.formatMessage(messages["settings"])}
            </a>

        let buttonGroup = [];
        const showButtons = Object.keys(this.props.filtersToUse).length > 0 || this.isCustomViewApplied()
        if (showButtons) {
            if (!(this.props.savedFilterId) && !(this.compareFilters()) || !(this.state.createdByCurrentUser)) {
                buttonGroup.push(saveAsNewButton);
            }
            else if (this.compareFilters()) {
                let buttons = [saveAsNewButton, saveButton, settingsButton];
                buttonGroup = [...buttons]
            } else if (this.props.savedFilterId && (this.state.createdByCurrentUser)) {
                let buttons = [saveAsNewButton, settingsButton];
                buttonGroup = [buttons];
            }
        }
        return (
            <div className="filter-toolbar">
                <div className="toolbar-container">
                    <div className="search-bar">
                        <div className="mb-2 input-group">
                            <DebounceInput
                                onKeyPress={this.props.onKeyPress}
                                minLength={0}
                                debounceTimeout={500}
                                autoComplete={this.props.autoComplete}
                                name={this.props.name}
                                onChange={this.props.onChange}
                                id={this.props.id}
                                value={this.props.value}
                                type="search"
                                className="form-control"
                                placeholder={this.props.placeholder}
                            />

                        </div>
                        <div className="row ml-2 mr-2 mb-0 ml-auto">
                            <div className='flex flex-column' >
                                <div>
                                    {
                                        this.props.filtersApplied.map(elem => {
                                            const filterToUse = this.props.filtersToUse[elem.nameId]
                                            if (!filterToUse) {
                                                return
                                            }

                                            const translatedMessage = messages[filterToUse.op]
                                            if (!translatedMessage) {
                                                return
                                            }

                                            const filterLabel =
                                                elem.label +
                                                " " +
                                                this.props.intl.formatMessage(translatedMessage) +
                                                " " +
                                                filterToUse.label

                                            return (elem.section === undefined && filterToUse !== undefined) ?
                                                <span key={elem.nameId + "-badge"} className="flex flex-row mr-1">
                                                    <a className="badge badge-primary text-white" onClick={() => this.removeFilter(elem.nameId)}>
                                                        <span className="mr-2 badgeFilter">
                                                            {filterLabel}</span>
                                                        <span>x</span>
                                                    </a>
                                                </span>
                                                : ''
                                        })
                                    }

                                    {
                                        showButtons ?
                                            <a type="button" className="badge badge-secondary text-white" onClick={() => this.props.onClearFilters()}>{this.props.intl.formatMessage(messages["clear_all_filters"])}</a>
                                            : ''
                                    }


                                </div>
                                <div className="d-flex flex-row pt-2">
                                    {
                                        buttonGroup.map((item) => (
                                            showButtons) ?
                                            <span key={item.key + "-button group"} className="btn-toolbar">
                                                {item}
                                            </span>
                                            : '')
                                    }
                                    <span className="btn-toolbar">
                                        <SavedFilterAlert
                                            onSaveClicked={this.state.onSaveClicked}
                                        />
                                    </span>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='search-actions'>
                        {!this.state.hideFilterDropdown &&
                            <FilterDropdown
                                onChangeSavedFilter={this.props.onChangeSavedFilter}
                                options={this.state.options}
                                savedFilterId={this.props.savedFilterId}
                                createdByCurrentUser={this.checkCreator}
                                userId={this.state.userId}
                            />
                        }
                        {!this.state.hideFilters &&
                            <button className="btn btn-outline-primary w-100 mb-2" data-toggle="modal" data-target="#filtersMenus" onClick={this.getModal}>
                                <Icon value={"filter"} />
                                <FormattedMessage
                                    id="common.filters.more_filters_btn"
                                    defaultMessage="Filters"
                                />
                            </button>
                        }
                        {this.props.children}
                    </div>
                </div>

                <div className='modal filter-modal' id='savedFiltersMenu' role="dialog" data-backdrop="static" data-keyboard="false" aria-hidden="true" >
                    <div className="modal-dialog modal-full" role="document">
                        {this.state.modal}
                    </div>
                </div>

                <div className='modal filter-modal' id='filtersMenus' role="dialog" data-backdrop="static" data-keyboard="false" aria-hidden="true" >
                    <div className="modal-dialog modal-full" role="document">
                        {this.state.modal}
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(FilterToolbar);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-menu/filterToolbar.component.jsx